import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { PermissionsTabComponent } from './pages/user-access/user-details/permissions-tab/permissions-tab.component';
import { GrantsTabComponent } from './pages/user-access/user-details/grants-tab/grants-tab.component';
import { permissionGuard } from './shared/permissions/permission.guard';
import { BrsPermission } from './shared/permissions/permission.model';

const routes: Routes = [
  {
    path: 'about-gea',
    loadComponent: () => import('./pages/about-gea/about-gea.component').then((m) => m.AboutGeaComponent),
  },
  {
    path: 'project-configurator/:projId/:prodId',
    loadComponent: () =>
      import('./pages/projects/project-configurator/product-configurator.component').then((m) => m.ProductConfiguratorComponent),
    canActivate: [permissionGuard],
    data: { permission: BrsPermission.CanViewProjects },
  },
  {
    path: 'projects',
    loadComponent: () => import('./pages/projects/projects.component').then((m) => m.ProjectsComponent),
    canActivate: [MsalGuard, permissionGuard],
    data: { permission: BrsPermission.CanViewProjects },
  },
  {
    path: 'project-reports/:id',
    loadComponent: () =>
      import('./pages/projects/project-reports/project-reports.component').then((m) => m.ProjectReportsComponent),
    canActivate: [MsalGuard, permissionGuard],
    data: { permission: BrsPermission.CanViewProjects },
  },
  {
    path: 'project-details/:id',
    loadComponent: () =>
      import('./pages/projects/project-details/project-details.component').then((m) => m.ProjectDetailsComponent),
    canActivate: [MsalGuard, permissionGuard],
    data: { permission: BrsPermission.CanViewProjects },
  },
  {
    path: 'home',
    component: DashboardComponent,
    canActivate: [MsalGuard],
  },
  {
    path: 'products',
    loadComponent: () => import('./pages/products/products.component').then((m) => m.ProductsComponent),
    canActivate: [MsalGuard, permissionGuard],
    data: { permission: BrsPermission.CanViewProducts },
  },
  {
    path: 'data-maintenance',
    loadComponent: () => import('./pages/data-maintenance/data-maintenance.component').then((m) => m.DataMaintenanceComponent),
    canActivate: [MsalGuard, permissionGuard],
    data: { permission: BrsPermission.CanManageData },
  },
  {
    path: 'data-maintenance/:assetId',
    loadComponent: () =>
      import('./pages/data-maintenance/content/data-maintenance-content.component').then(
        (m) => m.DataMaintenanceContentComponent
      ),
    canActivate: [MsalGuard, permissionGuard],
    data: { permission: BrsPermission.CanManageData },
  },
  {
    path: 'user-management',
    loadComponent: () => import('./pages/user-access/user-management.component').then((m) => m.UserManagementComponent),
    canActivate: [MsalGuard, permissionGuard],
    data: { permission: BrsPermission.CanManageUserPermissions },
  },
  {
    path: 'user/:id',
    loadComponent: () => import('./pages/user-access/user-details/user-details.component').then((m) => m.UserDetailsComponent),
    canActivate: [MsalGuard, permissionGuard],
    data: { permission: BrsPermission.CanManageUserPermissions },
    children: [
      { path: '', redirectTo: 'permissions', pathMatch: 'full' },
      {
        path: 'permissions',
        component: PermissionsTabComponent,
        canActivate: [MsalGuard],
      },
      {
        path: 'grants',
        component: GrantsTabComponent,
        canActivate: [MsalGuard],
      },
    ],
  },
  {
    path: '**',
    redirectTo: '/home',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(
      routes,
      { useHash: false, enableTracing: false } // <-- debugging purposes only
    ),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
